import { createSlice } from '@reduxjs/toolkit';

export const menuSlice = createSlice({
    name:'menus',
    initialState:{
        loading: false,
        
        data:[],
        error: false,
    },
    reducers:{
        MENU_FETCH_START:(state)=>{
            state.loading=true
        },
        MENU_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
            state.data=action.payload
            
        },
       
        MENU_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const {MENU_FETCH_ERROR,MENU_FETCH_START,MENU_FETCH_SUCCESS }=menuSlice.actions;
export default menuSlice.reducer;